import React from "react";
import { useTranslation } from "react-i18next";

// Components
import Modal from "../modal";
import Typography from "../Typography";
import LogoIcon from "../Svgs/LogoIcon";

// Styles
import styles from "./style.module.scss";

interface AlertModalProps {
  open: boolean;
  onClose: () => void;
  message: string;
}

const AlertModal: React.FC<AlertModalProps> = ({ open, onClose, message }) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={""}
      showCloseButton
      className={styles.modal}
    >
      <div className={styles.content}>
        <LogoIcon className={styles.logo} width={150} height={36} />
        <Typography variant="p" className={styles.message}>
          {message}
        </Typography>
      </div>
    </Modal>
  );
};

export default AlertModal;
